export const support = {
  seo: {
    title: 'Contact & Support | Bistroo',
    description: 'Contact the Bistroo support team by phone, WhatsApp or email. We will help you quickly.',
  },
  hero: {
    heading: {
      1: 'Our',
      2: 'customer service',
      3: 'is happy to help you',
    },
    description: {
      1: 'Welcome to our customer service',
      2: 'To assist you properly, we ask you to choose from the available options below. This way we make sure you are directed to the right information or contact option right away.',
    },
  },
  cards: {
    helpcenter: {
      description: 'All the information you need',
      title: 'Help Center & FAQ',
      text: 'Visit our help center for advice and answers to all your questions. Or check our FAQ page with the most frequently asked questions.',
      actions: {
        helpcenter: 'Visit the help center',
        faq: 'Most asked questions',
      },
    },
    demo: {
      description: 'Support team',
      title: 'A demo',
      text: 'Want a demo with our team?',
      action: {
        title: 'Request a demo',
        button: 'Request',
      },
    },
    address: {
      description: 'Bistroo',
      title: 'Our address',
      text: 'You can find us at the address below',
      address: {
        mail: 'Mailing address:',
        visit: 'Visiting address (by appointment)',
      },
    },
    contact: {
      description: 'Get in touch',
      title: 'Contact',
      text: 'Want to contact us directly? You can!',
    },
    partners: {
      description: 'Become a partner',
      title: 'Partners',
      text: 'Grow your business and become a partner of Bistroo!',
      action: {
        title: 'Become a partner',
        button: 'Read more',
      },
    },
  },
}
